/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ loadText: NonNullable<unknown> }} Progress_Report_Record_BeforeInputs */

const en_us2_progress_report_record_before = /** @type {(inputs: Progress_Report_Record_BeforeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`was ${i?.loadText}`)
};

const pt_br2_progress_report_record_before = /** @type {(inputs: Progress_Report_Record_BeforeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`antes ${i?.loadText}`)
};

const es_419_progress_report_record_before = /** @type {(inputs: Progress_Report_Record_BeforeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`antes ${i?.loadText}`)
};

const pt_pt2_progress_report_record_before = /** @type {(inputs: Progress_Report_Record_BeforeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`antes ${i?.loadText}`)
};

const fr_fr2_progress_report_record_before = /** @type {(inputs: Progress_Report_Record_BeforeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`avant ${i?.loadText}`)
};

const de_de2_progress_report_record_before = /** @type {(inputs: Progress_Report_Record_BeforeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vorher ${i?.loadText}`)
};

const it_it2_progress_report_record_before = /** @type {(inputs: Progress_Report_Record_BeforeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`prima ${i?.loadText}`)
};

/**
* | output |
* | --- |
* | "was {loadText}" |
*
* @param {Progress_Report_Record_BeforeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_record_before = /** @type {((inputs: Progress_Report_Record_BeforeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Record_BeforeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_record_before(inputs)
	if (locale === "es-419") return es_419_progress_report_record_before(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_record_before(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_record_before(inputs)
	if (locale === "de-DE") return de_de2_progress_report_record_before(inputs)
	if (locale === "it-IT") return it_it2_progress_report_record_before(inputs)
	return en_us2_progress_report_record_before(inputs)
});
export { progress_report_record_before as "progress-report.record_before" }